// /src/mixins/postSidebarMixin.js
import TaxonomyGroup from '@/components/common/Sidebar/TaxonomyGroup'

export const taxiesGroup = {
  components: {
    TaxonomyGroup,
  },

  computed: {
    taxiesGroup() {
      const { post } = this
      const output = []
      let { type } = post

      if (typeof post['origins'] != 'undefined' && post['origins'].length > 0) {
        output.push({
          label: 'Meeting Type',
          type,
          queryProp: 'origins',
          taxies: this.$store.getters['taxies/findItemsByIDArray'](
            'origins',
            post['origins'],
          ),
        })
      }
      if (
        typeof post['deal_types'] != 'undefined' &&
        post['deal_types'].length > 0
      ) {
        output.push({
          label: 'Deal Type(s)',
          type,
          queryProp: 'deal_types',
          taxies: this.$store.getters['taxies/findItemsByIDArray'](
            'deal_types',
            post['deal_types'],
          ),
        })
      }
      if (
        typeof post['deal-phases'] != 'undefined' &&
        post['deal-phases'].length > 0
      ) {
        output.push({
          label: 'Deal Phase',
          type,
          queryProp: 'deal_phases',
          taxies: this.$store.getters['taxies/findItemsByIDArray'](
            'dealPhases',
            post['deal-phases'],
          ),
        })
      }
      if (
        typeof post['verticals'] != 'undefined' &&
        post['verticals'].length > 0
      ) {
        output.push({
          label: 'Vertical(s)',
          type,
          queryProp: 'verticals',
          taxies: this.$store.getters['taxies/findItemsByIDArray'](
            'verticals',
            post['verticals'],
          ),
        })
      }
      if (
        typeof post['industries'] != 'undefined' &&
        post['industries'].length > 0
      ) {
        output.push({
          label: 'Industries',
          type,
          queryProp: 'industries',
          taxies: this.$store.getters['taxies/findItemsByIDArray'](
            'industries',
            post['industries'],
          ),
        })
      }
      if (
        typeof post['geographies'] != 'undefined' &&
        post['geographies'].length > 0
      ) {
        output.push({
          label: 'Geography',
          type,
          queryProp: 'geographies',
          taxies: this.$store.getters['taxies/findItemsByIDArray'](
            'geographies',
            post['geographies'],
          ),
        })
      }
      if (
        typeof post['services'] != 'undefined' &&
        post['services'].length > 0
      ) {
        output.push({
          label: 'Service(s)',
          type,
          queryProp: 'services',
          taxies: this.$store.getters['taxies/findItemsByIDArray'](
            'services',
            post['services'],
          ),
        })
      }
      if (typeof post['bible_topics'] != 'undefined' && post['bible_topics'].length > 0) {
        output.push({
          label: 'Bible Study Topics(s)',
          type,
          queryProp: 'bible_topics',
          taxies: this.$store.getters['taxies/findItemsByIDArray'](
            'bibleTopics',
            post['bible_topics'],
          ),
        })
      }
      if (typeof post['scripture_references'] != 'undefined' && post['scripture_references'].length > 0) {
        output.push({
          label: 'Scripture References',
          type,
          queryProp: 'scripture_references',
          taxies: this.$store.getters['taxies/findItemsByIDArray'](
            'scriptureReferences',
            post['scripture_references'],
          ),
        })
      }
      if (typeof post['tags'] != 'undefined' && post['tags'].length > 0) {
        output.push({
          label: 'Other Keyword(s)',
          type,
          queryProp: 'tags',
          taxies: this.$store.getters['taxies/findItemsByIDArray'](
            'tags',
            post['tags'],
          ),
          style: 'inline',
        })
      }
      return output
    },
  },
}
